import axios from 'axios'

export const strapiApi = axios.create({
	baseURL:	process.env.REACT_APP_STRAPI_URL,
})

export const fetchEducationData = async () => {
  try {
    const response = await strapiApi.get('/api/education', {
      params: {
        populate: {
          SportProgramsFile: true,
          sports: {
            populate: ['File'] // Make sure this matches your field name
          }
        }
      }
    });
    return response.data.data.attributes;
  } catch (error) {
    console.error('Error fetching education data:', error);
    throw error;
  }
}

export const searchContent = async (query) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/search/`, {
      params: { q: query }
    });
    return response.data;
  } catch (error) {
    console.error('Search error:', error);
    throw error;
  }
};

export const fetchBranchesBySport = async (sportId) => {
  try {
    const response = await strapiApi.get(`/api/branches`, {
      params: {
        populate: '*',
        filters: {
          programs: {
            sport: {
              id: sportId
            }
          }
        }
      }
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching branches by sport:', error);
    throw error;
  }
}

export const fetchPrograms = async ({ 
  populate = '*',
  sort = 'createdAt:desc',
  filters = {}
}) => {
  try {
    const params = {
      populate,
      sort
    };

    if (filters.sport) {
      params['filters[sport][id][$eq]'] = filters.sport;
    }

    if (filters.branches) {
      params['filters[branches][id][$eq]'] = filters.branches;
    }

    const response = await strapiApi.get('/api/programs', { params });
    return {
      data: response.data.data,
      pagination: response.data.meta?.pagination
    };
  } catch (error) {
    console.error('Error fetching programs:', error);
    throw error;
  }
}

export const fetchSports = async ({ 
  populate = '*',
  sort = 'Title:asc'
}) => {
  try {
    const response = await strapiApi.get('/api/sports', {
      params: {
        populate,
        sort
      }
    });
    return {
      data: response.data.data,
      pagination: response.data.meta?.pagination
    };
  } catch (error) {
    console.error('Error fetching sports:', error);
    throw error;
  }
}

export const fetchBranches = async ({ 
  populate = '*',
  sort = 'Title:asc'
}) => {
  try {
    const response = await strapiApi.get('/api/branches', {
      params: {
        populate,
        sort
      }
    });
    return {
      data: response.data.data,
      pagination: response.data.meta?.pagination
    };
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
}

export const fetchFacilities = async () => {
  try {
    const response = await strapiApi.get('/api/branches?populate=*');
    return {
      data: response.data.data,
      pagination: response.data.meta?.pagination
    };
  } catch (error) {
    console.error('Error fetching facilities:', error);
    throw error;
  }
}

export const fetchFacilityById = async (id) => {
  try {
    const response = await strapiApi.get(`/api/branches/${id}`, {
      params: {
        populate: {
          Image: true,
          facility_medias: {
            populate: {
              Image: true  // This will populate the Image for each facility_media
            }
          }
        }
      }
    });
    
    return {
      data: response.data.data,
      id: response.data.data.id
    };
  } catch (error) {
    console.error('Error fetching facility:', error);
    throw error;
  }
}

export const fetchEvents = async ({ 
  page = 1, 
  pageSize = 100,
  populate = '*',
  sort = 'start:asc',
  filters = {}
}) => {
  try {
    const params = {
      'pagination[page]': page,
      'pagination[pageSize]': pageSize,
      populate,
      sort
    };

    // Add filters if provided
    if (filters.type) {
      params['filters[type][$eq]'] = filters.type;
    }
    if (filters.start_gte) {
      params['filters[start][$gte]'] = filters.start_gte;
    }
    if (filters.end_lte) {
      params['filters[end][$lte]'] = filters.end_lte;
    }

    const response = await strapiApi.get('/api/events?populate=*');
    return {
      data: response.data.data,
      pagination: response.data.meta?.pagination
    };
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
}

export const fetchNews = async ({ page = 1, pageSize = 9}) => {
  try {
    const response = await strapiApi.get(`/api/newss?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`)
        return {
            data: response.data.data,
            pagination: response.data.meta?.pagination
        }
  } catch (error) {
        console.error('Error fetching news:', error)
        throw error
  }
}

export const fetchCoaches = async ({ page = 1, pageSize = 9}) => {
  try {
    const response = await strapiApi.get(`/api/coaches?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`)
        return {
            data: response.data.data,
            pagination: response.data.meta?.pagination
        }
  } catch (error) {
        console.error('Error fetching news:', error)
        throw error
  }
}

export const fetchAchievements = async ({ page = 1, pageSize = 9}) => {
  try {
    const response = await strapiApi.get(`/api/achievements?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`)
        return {
            data: response.data.data,
            pagination: response.data.meta?.pagination
        }
  } catch (error) {
        console.error('Error fetching news:', error)
        throw error
  }
}

export const fetchGalleryImages = async ({ page = 1, pageSize = 9}) => {
  try {
    const response = await strapiApi.get(`/api/gallery-images?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`)
        return {
            data: response.data.data,
            pagination: response.data.meta?.pagination
        }
  } catch (error) {
        console.error('Error fetching news:', error)
        throw error
  }
}

export const fetchGalleryVideos = async ({ page = 1, pageSize = 9}) => {
  try {
    const response = await strapiApi.get(`/api/gallery-videos?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`)
        return {
            data: response.data.data,
            pagination: response.data.meta?.pagination
        }
  } catch (error) {
        console.error('Error fetching news:', error)
        throw error
  }
}

export const fetchFacilityGymPhotos = async (facilityId, { page = 1, pageSize = 9 }) => {
  try {
    const response = await strapiApi.get(`/api/facilities/${facilityId}?populate=*`)
    
    return {
      data: response.data.data.attributes.GymPhotos.data,
      pagination: response.data.data.attributes.GymPhotos.meta.pagination
    };
  } catch (error) {
    console.error('Error fetching facility gym photos:', error);
    throw error;
  }
}

export const fetchMainInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/main-info/`);
    console.log('MainInfo API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching main info:', error);
    throw error;
  }
}

export const fetchStructureInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/structure-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching structure info:', error);
    throw error;
  }
}

export const fetchDocumentsInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/documents-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching documents info:', error);
    throw error;
  }
}

export const fetchEducationInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/education-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching education info:', error);
    throw error;
  }
}

export const fetchManagementInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/management-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching management info:', error);
    throw error;
  }
}

export const fetchEquipmentInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/equipment-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching equipment info:', error);
    throw error;
  }
}

export const fetchActivityInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/activity-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching activity info:', error);
    throw error;
  }
}

export const fetchVacantInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/vacant-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vacant info:', error);
    throw error;
  }
}

export const fetchScholarshipInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/scholarship-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching scholarship info:', error);
    throw error;
  }
}

export const fetchFoodInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/food-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching food info:', error);
    throw error;
  }
}

export const fetchRequirementsInfo = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_STRAPI_URL}api/requirements-info/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching requirements info:', error);
    throw error;
  }
}
